import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import logo from 'images/Alphaeon_Flex_Logo.png';
function Header() {
    return (_jsx("div", { className: "flex-finalize-header", children: _jsx("img", { src: logo, className: "logo", alt: "Logo" }) }));
}
export default memo(Header);
